import ajaxRequest from "../../utils/ajaxRequest";
import { API_PARAM } from "./apiParam";
import { API_QUERY } from "./apiQuery";

export default async function GetNotesPAData(data) {
    const { productId, formularyId, indicationId } = data;
    const url = `${API_QUERY.formulary.notes.structuredPA}ProductId=${productId}&FormularyId=${formularyId}&IndicationId=${indicationId}`; // Add URL to modal
    const promiseObj = new Promise(resolve => {
        ajaxRequest({
            url,
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${API_PARAM.token}`
            }
        })
            .then(res => {
                if (!res) {
                    resolve(false);
                    return;
                }
                const rs = JSON.parse(res);
                // if (data === "nocontent") return ["", "nocontent"];
                // Remove the <BR> tag from the first line
                let note = rs.StructuredNotes[0].Note.replace(/[\n\r]+/g, "");
                // Remove concurrent <br> tags (showing at end of returned data)
                note = note.replace("<BR>", "");
                // Second: Break into array at the <br>
                note = note.replace("<br><br>", "");
                // Third: Create new object with key/value pairs
                const noteRows = note.split("<br>");
                const noteObject = {};
                noteRows.forEach(item => {
                    const element = item;
                    const keyValue = element.split(": ");
                    const key = keyValue[0];
                    let value = keyValue[1]; // If the value contains a ":" in the string, combine that back together

                    if (keyValue[2] !== undefined) {
                        value = `${keyValue[1]}: ${keyValue[2]}`;
                    }

                    noteObject[key] = value;
                });
                resolve(noteObject);
            })
            .catch(error => {
                console.error("Error:", error); // eslint-disable-line
                resolve(false);
            });
    });
    return promiseObj;
}
